import React from "react";
import { Route, Navigate, RouteProps } from "react-router-dom";

// components
import PrivateRoute from "./PrivateRoute";
import ReferalUses from "../pages/master/UserReferals";
import TestOtps from "../pages/master/TestOtps";

// auth2
const Login2 = React.lazy(() => import("../pages/auth2/Login2"));
const Logout2 = React.lazy(() => import("../pages/auth2/Logout2"));
const Register2 = React.lazy(() => import("../pages/auth2/Register2"));
const Confirm2 = React.lazy(() => import("../pages/auth2/Confirm2"));
const ForgetPassword2 = React.lazy(() => import("../pages/auth2/ForgetPassword2"));
const ResetPassword2 = React.lazy(() => import("../pages/auth2/ResetPassword2"));
const LockScreen2 = React.lazy(() => import("../pages/auth2/LockScreen2"));
const SignInSignUp2 = React.lazy(() => import("../pages/auth2/SignInSignUp2"));

// dashboard
const Dashboard4 = React.lazy(() => import("../pages/dashboard/Dashboard4/"));

// master data

const Users = React.lazy(() => import("../pages/master/Users"));
const Locations = React.lazy(() => import("../pages/master/Locations"));
const Corporates = React.lazy(() => import("../pages/master/Corporates"));
const Packages = React.lazy(() => import("../pages/master/Packages"));
const Devices = React.lazy(() => import("../pages/master/Devices"));
const PowerBanks = React.lazy(() => import("../pages/master/PowerBanks"));
const Rentals = React.lazy(() => import("../pages/master/Rentals"));
const Kyc = React.lazy(() => import("../pages/master/Kyc"));
const DeviceMedia = React.lazy(() => import("../pages/master/DeviceMedia"));
const Checks = React.lazy(() => import("../pages/master/Checks"));
const RevenueReport = React.lazy(() => import("../pages/master/DeviceReports"));
const RentalsReports = React.lazy(() => import("../pages/master/RentalsReport"));
const LocationsReports = React.lazy(() => import("../pages/master/LocationsReport"));
const Complaints = React.lazy(() => import("../pages/master/Complaints"));
const Withdraws = React.lazy(() => import("../pages/master/WithDrawRequests"));
const WattiTemplates = React.lazy(() => import("../pages/master/WattiTemplates"));
const OffersList = React.lazy(() => import("../pages/master/OffersList"));

export interface RoutesProps {
  path: RouteProps["path"];
  name?: string;
  element?: RouteProps["element"];
  route?: any;
  exact?: boolean;
  icon?: string;
  header?: string;
  roles?: string[];
  children?: RoutesProps[];
}

const dashboardRoutes: RoutesProps = {
  path: "/dash",
  name: "Dashboards",
  icon: "airplay",
  header: "Navigation",
  children: [
    {
      path: "/",
      name: "Root",
      element: <Navigate to="/dashboard" />,
      route: PrivateRoute,
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      element: <Dashboard4 />,
      route: PrivateRoute,
    },
  ],
};

const masterDataRoutes: RoutesProps = {
  path: "/master",
  name: "Master",
  icon: "airplay",
  header: "Navigation",
  children: [
    // {
    //   path: "/otps",
    //   name: "Otps (Test)",
    //   element: <TestOtps />,
    //   route: PrivateRoute,
    // },
    {
      path: "/users",
      name: "Users",
      element: <Users />,
      route: PrivateRoute,
    },
    {
      path: "/locations",
      name: "Locations",
      element: <Locations />,
      route: PrivateRoute,
    },
    {
      path: "/corporates",
      name: "Corporates",
      element: <Corporates />,
      route: PrivateRoute,
    },
    {
      path: "/packages",
      name: "Packages",
      element: <Packages />,
      route: PrivateRoute,
    },
    {
      path: "/devices",
      name: "Devices",
      element: <Devices />,
      route: PrivateRoute,
    },
    {
      path: "/powerbanks",
      name: "Power Banks",
      element: <PowerBanks />,
      route: PrivateRoute,
    },
    {
      path: "/kyc_list",
      name: "Kyc List",
      element: <Kyc />,
      route: PrivateRoute,
    },
    {
      path: "/rentals",
      name: "Rentals",
      element: <Rentals />,
      route: PrivateRoute,
    },
    {
      path: "/device-media",
      name: "Device Media",
      element: <DeviceMedia />,
      route: PrivateRoute,
    },
    {
      path: "/checks",
      name: "Checks",
      element: <Checks />,
      route: PrivateRoute,
    },
    {
      path: "/otps",
      name: "Test Otps",
      element: <TestOtps />,
      route: PrivateRoute,
    },
    {
      path: "/reports/rentals",
      name: "Reports Rentals",
      element: <RentalsReports />,
      route: PrivateRoute,
    },
    {
      path: "/reports/revenue",
      name: "Reports Revenue",
      element: <RevenueReport />,
      route: PrivateRoute,
    },
    // {
    //   path: "/reports/location",
    //   name: "Reports Locations",
    //   element: <LocationsReports />,
    //   route: PrivateRoute,
    // },
    {
      path: "/referrals",
      name: "Referrals",
      element: <ReferalUses />,
      route: PrivateRoute,
    },
    {
      path: "/complaints",
      name: "Compalints",
      element: <Complaints />,
      route: PrivateRoute,
    },
    {
      path: "/withdraws",
      name: "Withdraws",
      element: <Withdraws />,
      route: PrivateRoute,
    },
    {
      path: "/master/watti",
      name: "WhatsApp Templates",
      element: <WattiTemplates />,
      route: PrivateRoute,
    },
    {
      path: "/master/offers",
      name: "Offers",
      element: <OffersList />,
      route: PrivateRoute,
    },
  ],
};

// pages

// auth
const authRoutes: RoutesProps[] = [
  {
    path: "/auth/login2",
    name: "Login2",
    element: <Login2 />,
    route: Route,
  },
  {
    path: "/auth/logout2",
    name: "Logout2",
    element: <Logout2 />,
    route: Route,
  },
  {
    path: "/auth/register2",
    name: "Register2",
    element: <Register2 />,
    route: Route,
  },
  {
    path: "/auth/confirm2",
    name: "Confirm2",
    element: <Confirm2 />,
    route: Route,
  },
  {
    path: "/auth/forget-password2",
    name: "Forget Password2",
    element: <ForgetPassword2 />,
    route: Route,
  },
  {
    path: "/auth/reset-password2",
    name: "Reset Password2",
    element: <ResetPassword2 />,
    route: Route,
  },
  {
    path: "/auth/signin-signup2",
    name: "SignIn-SignUp2",
    element: <SignInSignUp2 />,
    route: Route,
  },
  {
    path: "/auth/lock-screen2",
    name: "Lock Screen2",
    element: <LockScreen2 />,
    route: Route,
  },
];

// flatten the list of all nested routes
const flattenRoutes = (routes: RoutesProps[]) => {
  let flatRoutes: RoutesProps[] = [];

  routes = routes || [];
  routes.forEach((item: RoutesProps) => {
    flatRoutes.push(item);

    if (typeof item.children !== "undefined") {
      flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
    }
  });
  return flatRoutes;
};

// All routes
const authProtectedRoutes = [dashboardRoutes, masterDataRoutes];
const publicRoutes = [...authRoutes];

const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes]);
const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes]);
export { publicRoutes, authProtectedRoutes, authProtectedFlattenRoutes, publicProtectedFlattenRoutes };
